import { write, utils } from "xlsx";
import { saveAs } from "file-saver";

export class ReportGenerator {
    createReport(data) {
        const workbook = utils.book_new();

        const worksheet = utils.aoa_to_sheet(data);

        utils.book_append_sheet(workbook, worksheet, "Report");

        return workbook;
    }

    downloadReport(workbook, filename) {
        const workbookOut = write(workbook, { type: "array" });

        const blob = new Blob([workbookOut], {
            type: "application/octet-stream",
        });
        saveAs(blob, filename);
    }
}
